import { HeroNumberWithFields } from "@aidkitorg/types/lib/survey";
import { ReportFilterConfig } from "@aidkitorg/types/lib/admin-panel/filters";
import { useState, useEffect } from "react";
import { BooleanExprToFilterGroupConverter, FilterGroupToBooleanExprConverter } from "../../shared/utils/filterConverters";

export const useApplicantCountFormState = (component?: HeroNumberWithFields) => {
  const [title, setTitle] = useState<string>('Total Applicants');
  const [filterConfig, setFilterConfig] = useState<ReportFilterConfig | undefined>(undefined);

  // Initialize form state from component if editing
  useEffect(() => {
    if (!component) return;

    // Initialize title
    if (typeof component.title === 'string') {
      setTitle(component.title);
    }

    if (component.filter) {
      try {
        const convertedFilter = BooleanExprToFilterGroupConverter.convert(component.filter);
        if (convertedFilter) {
          setFilterConfig({ enabled: true, config: convertedFilter });
        }
      } catch (error) {
        console.warn('Failed to convert saved filter config:', error);
      }
    }
  }, [component]);

  const buildApplicantCountObject = (): HeroNumberWithFields => {
    const applicantCount: HeroNumberWithFields = {
      kind: 'Hero Number',
      title: title,
      summary: {
        kind: 'Count'
      },
      useCommas: true,
    };

    // Add filter if it's configured
    if (filterConfig && filterConfig.enabled && filterConfig.config) {
      const booleanExpr = FilterGroupToBooleanExprConverter.convertFromConfig(filterConfig);
      if (booleanExpr) {
        applicantCount.filter = booleanExpr;
      }
    }

    return applicantCount;
  };

  const isFormStateValid = title.trim().length > 0;

  return {
    title,
    setTitle,
    filterConfig,
    setFilterConfig,
    buildApplicantCountObject,
    isFormStateValid
  };
};